import { SITE_URL } from '../resolveSEO';

interface Input {
  isHomePage: boolean;
  description: string;
  image: string;
}

export const buildSoftwareApplication = ({
  isHomePage,
  description,
  image,
}: Input) => {
  if (!isHomePage) return null;
  return {
    '@type': 'SoftwareApplication',
    '@id': `${SITE_URL}/#software`,
    name: 'Airhead Games',
    applicationCategory: 'GameApplication',
    operatingSystem: 'Web Browser',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    description,
    url: SITE_URL,
    screenshot: image,
  };
};
